import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { corporateCMSApi, post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useAirportServicesAndIncentives } from "../../BusinessOppurtunities.hook";
import { fields } from "../../constants";

export const AddEditAirlineServicesAndIncentives = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [records, setRecords] = useState<any[]>([]);
  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useAirportServicesAndIncentives(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);
  const getRecords = () => {
    let url = `/api/get-all-airlines/all-fields`;
    corporateCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch((err) => {
        setRecords([]);
      });
  };
  useEffect(() => {
    getRecords();
  }, []);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      published: dataById
        ? decodeHTML(dataById.payload?.published)
        : editData
          ? decodeHTML(editData?.published)
          : false,
      title: dataById ? decodeHTML(dataById.payload.title) : editData ? decodeHTML(editData?.title) : "",
      field_title_ms: dataById
        ? decodeHTML(dataById.payload.field_title_ms)
        : editData
          ? decodeHTML(editData.field_title_ms)
          : "",
      field_title_zh: dataById
        ? decodeHTML(dataById.payload.field_title_zh)
        : editData
          ? decodeHTML(editData?.field_title_zh)
          : "",
      field_airlines_description_en: dataById
        ? decodeHTML(dataById.payload.field_airlines_description_en)
        : editData
          ? decodeHTML(editData?.field_airlines_description_en)
          : "",
      field_airline_description_ms: dataById
        ? decodeHTML(dataById.payload.field_airline_description_ms)
        : editData
          ? decodeHTML(editData.field_airline_description_ms)
          : "",
      field_airline_description_zh: dataById
        ? decodeHTML(dataById.payload.field_airline_description_zh)
        : editData
          ? decodeHTML(editData?.field_airline_description_zh)
          : "",
      // field_airline_page_en: dataById
      // ? decodeHTML(dataById.payload.field_airline_page_en)
      // : editData
      // ? decodeHTML(editData?.field_airline_page_en)
      // : "",
      // field_airline_page_ms: dataById
      // ? decodeHTML(dataById.payload.field_airline_page_ms)
      // : editData
      // ? decodeHTML(editData?.field_airline_page_ms)
      // : "",
      // field_airline_page_zh: dataById
      // ? decodeHTML(dataById.payload.field_airline_page_zh)
      // : editData
      // ? decodeHTML(editData?.field_airline_page_zh)
      // : "",
      field_airline_order_sequence: dataById
        ? decodeHTML(dataById.payload.field_airline_order_sequence)
        : editData
          ? decodeHTML(editData?.field_airline_order_sequence)
          : "",
      field_islarge: dataById ? decodeHTML(dataById?.payload?.field_islarge) : decodeHTML(editData?.field_islarge),
      field_airline_image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_airline_image.png",
              status: "done",
              url: dataById?.payload?.field_airline_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_airline_image.png",
              status: "done",
              url: editData?.field_airline_image,
            },
          ]),
    },
    fields: fields.airlineServicesFacilities?.map((field: any) => {
      if (field.name === "field_airline_order_sequence") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;
              const existingRecord = records.find((record: any) => {
                return (
                  toInteger(record[field.name]) === toInteger(value) &&
                  record.id !== (editData?.id || dataById?.payload?.id)
                );
              });
              return !existingRecord || `${field.label || field.name} already exists`;
            },
          },
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["field_airline_image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    // let descKeys: any = [
    //     "field_airline_description_ms",
    //     "field_airline_description_zh",
    //     "field_airlines_description_en",
    //   ];
    //   for (const key of descKeys) {
    //     try {
    //       data[key] = {
    //         value: data[key] || "",
    //         format: "full_html",
    //       };
    //     } catch (error) {}
    //   }

    const payload = {
      action: action,
      method: method,
      module: "Business Opportunities",
      subModule: `airlineServices_airlineServicesFacilities_airlineServicesFacilitiesPageContent`,
      type: "DEDICATED",
      moduleKey: "MAHB_CORPORATE_Business Opportunities_Airline Services",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        field_airline_page_en: "airline-services-facilities",
        field_airline_page_ms: " ",
        field_airline_page_zh: " ",
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Airline Services Facilities`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${corporateHost}/api/airlines-view/${editData?.id || dataById?.payload?.id}`
              : `${corporateHost}/api/create/airlines-view`,
            query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Business Opportunities"
      />
    </ContentWrapper>
  );
};
